const toOptions = (keys) =>
  keys.map((key) => ({
    value: key,
    label: key
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "),
  }));

const labelMap = (options) =>
  options.reduce((acc, item) => ({ ...acc, [item.value]: item.label }), {});

export const moduleOptions = toOptions([
  "USER",
  "LIBRARY",
  "FLEET",
  "BRIEFING",
  "OFP",
  "WNB",
  "PERFORMANCE",
  "REPORT",
  "AIRLINE",
  "FLIGHT",
  "EFB",
  "FORM",
  "MESSAGE",
  "TICKET",
  "SOLAR_YEAR",
  "LEARNING",
]).map((item) =>
  ["OFP", "WNB", "EFB"].includes(item.value)
    ? { ...item, label: item.value }
    : item
);

export const visualizationOptions = toOptions([
  "KPI",
  "TABLE",
  "BAR_CHART",
  "COLUMN_CHART",
  "LINE_CHART",
  "AREA_CHART",
  "PIE_CHART",
  "DONUT",
  "GAUGE",
  "BUBBLE_CHART",
]).map((item) => (item.value === "KPI" ? { ...item, label: "KPI" } : item));

export const moduleLabels = labelMap(moduleOptions);
export const visualizationLabels = labelMap(visualizationOptions);

export const activeOptions = [
  { value: "all", label: "All" },
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];

export const WIDGETS_BASE = "/v2/widgets";
export const BACKFILL_SERVICES_BASE = "/v2/backfill-services";

/* ---------------------------- Available filters --------------------------- */
// Contract for widget.available_filters, shared with EFBEnrouteFront, which
// renders a filter form per dashboard widget from these definitions:
// { key, label, type, required, options?: [{ value, label }],
//   source?: { url, value_field, label_field } }
export const filterTypeOptions = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "boolean", label: "Boolean" },
  { value: "date", label: "Date" },
  { value: "date_range", label: "Date Range" },
  { value: "select", label: "Select" },
  { value: "multi_select", label: "Multi Select" },
];

export const SELECT_FILTER_TYPES = ["select", "multi_select"];

export const FILTER_KEY_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;

/* -------------------------- Visualization options ------------------------- */
// Contract for widget.visualization_options, shared with EFBEnrouteFront
// (src/app/components/modules/widgets/options.js), which applies these as
// display defaults. Keep keys and defaults in sync with that file.
export const chartOptionDefaults = {
  x_axis_title: "",
  y_axis_title: "",
  value_suffix: "",
  color: "#7CB5EC",
  fill_opacity: 0.75,
  curve: "linear",
  show_points: true,
  show_tooltip: true,
  show_grid: true,
  show_legend: false,
  begin_at_zero: true,
  thousands_separator: true,
  x_label_rotation: 45,
  bar_width: 0.6,
  line_width: 2,
  slice_labels: "percent",
};

// Per-type defaults applied over chartOptionDefaults.
export const typeOptionDefaults = {
  LINE_CHART: { show_points: false },
  PIE_CHART: { show_legend: true },
};

export const curveOptions = [
  { value: "linear", label: "Straight" },
  { value: "smooth", label: "Smooth" },
];

export const sliceLabelOptions = [
  { value: "percent", label: "Percentage" },
  { value: "value", label: "Value" },
  { value: "none", label: "None" },
];

const commonChartFields = [
  "x_axis_title",
  "y_axis_title",
  "value_suffix",
  "color",
  "show_tooltip",
  "show_grid",
  "show_legend",
  "begin_at_zero",
  "thousands_separator",
  "x_label_rotation",
];

// Visualization types whose options are edited in the widget form.
export const visualizationOptionFields = {
  LINE_CHART: [...commonChartFields, "curve", "line_width", "show_points"],
  AREA_CHART: [
    ...commonChartFields,
    "fill_opacity",
    "curve",
    "line_width",
    "show_points",
  ],
  COLUMN_CHART: [...commonChartFields, "fill_opacity", "bar_width"],
  // `color` is the first slice; the next slices use the shared palette.
  PIE_CHART: [
    "value_suffix",
    "color",
    "slice_labels",
    "show_tooltip",
    "show_legend",
    "thousands_separator",
  ],
};
